/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router';
import { connect, actions } from 'data';

import { basePath } from 'constants/urls';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  logout: actions.session.logout,
};

class SignOut extends React.Component {
  static propTypes = {
    logout: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  componentDidMount() {
    this.props.logout();
  }

  render() {
    return <Navigate to={basePath} replace />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignOut);
